<interacta-user-notification [notification]="notification()">
    @if (notification().postDataChangedValues; as changedValues) {
        <div class="mt-8 flex flex-col gap-y-4">
            @if (
                changedValues.assignee?.newValue !==
                changedValues.assignee?.oldValue
            ) {
                <div class="flex items-center gap-x-4">
                    @let oldValueAssignee =
                        changedValues.assignee?.oldValue ??
                        emptyMemberPlaceholder;
                    @let newValueAssignee =
                        changedValues.assignee?.newValue ??
                        emptyMemberPlaceholder;

                    <interacta-member
                        [compactUserName]="
                            oldValueAssignee.innerId !==
                            emptyMemberPlaceholder.innerId
                        "
                        [fontWeight]="'regular'"
                        [member]="oldValueAssignee | apply: markAsDeleted"
                        [memberClickBehavior]="'none'"
                        [size]="'extra-small'"
                    />

                    <interacta-icon class="size-16" [icon]="'arrow-right'" />

                    <interacta-member
                        [compactUserName]="
                            newValueAssignee.innerId !==
                            emptyMemberPlaceholder.innerId
                        "
                        [fontWeight]="'regular'"
                        [member]="newValueAssignee"
                        [memberClickBehavior]="'none'"
                        [size]="'extra-small'"
                    />
                </div>
            }

            @if (
                changedValues.expectedStartDate || changedValues.expectedEndDate
            ) {
                <div class="flex items-center gap-x-4">
                    @let expectedStart = changedValues.expectedStartDate;

                    @let expectedEnd = changedValues.expectedEndDate;

                    @let oldVisible =
                        !!expectedStart?.oldValue || !!expectedEnd?.oldValue;
                    @let newVisible =
                        !!expectedStart?.newValue || !!expectedEnd?.newValue;

                    @if (oldVisible) {
                        <interacta-activity-date-container
                            [activity]="{
                                expectedStart:
                                    expectedStart?.oldValue ?? undefined,
                                expectedEnd: expectedEnd?.oldValue ?? undefined,
                            }"
                            [lineThrough]="true"
                        />
                    }

                    @if (oldVisible && newVisible) {
                        <interacta-icon
                            class="size-16"
                            [icon]="'arrow-right'"
                        />
                    }

                    @if (newVisible) {
                        <interacta-activity-date-container
                            [activity]="{
                                expectedStart:
                                    expectedStart?.newValue ?? undefined,
                                expectedEnd: expectedEnd?.newValue ?? undefined,
                            }"
                        />
                    }
                </div>
            }
        </div>
    }
</interacta-user-notification>
